/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePinByOtpDto } from '../models/CreatePinByOtpDto';
import type { CreatePinByOtpEntity } from '../models/CreatePinByOtpEntity';
import type { SendOtpDto } from '../models/SendOtpDto';
import type { SendOtpEntity } from '../models/SendOtpEntity';
import type { VerifyOtpDto } from '../models/VerifyOtpDto';
import type { VerifyOtpEntity } from '../models/VerifyOtpEntity';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AuthOtpPinService {
  /**
   * @param requestBody
   * @returns SendOtpEntity
   * @throws ApiError
   */
  public static otpPinControllerSendOtp(
    requestBody: SendOtpDto,
  ): CancelablePromise<SendOtpEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/auth/otp/send',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param requestBody
   * @returns VerifyOtpEntity
   * @throws ApiError
   */
  public static otpPinControllerVerifyOtp(
    requestBody: VerifyOtpDto,
  ): CancelablePromise<VerifyOtpEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/auth/otp/verify',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param requestBody
   * @returns CreatePinByOtpEntity
   * @throws ApiError
   */
  public static otpPinControllerCreatePin(
    requestBody: CreatePinByOtpDto,
  ): CancelablePromise<CreatePinByOtpEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/auth/pin/create',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
